import { useTheme } from '@mui/material/styles';
import { ExtendedMuiTheme } from '../themes/types';
import { SemanticTokens } from '../tokens/semantic';

/**
 * Hook to access semantic theme colors
 * 
 * @example
 * ```tsx
 * const colors = useThemeColors();
 * <Box sx={{ backgroundColor: colors.background.primary }}>
 * ```
 */
export function useThemeColors(): SemanticTokens {
  const theme = useTheme() as ExtendedMuiTheme;
  return theme.ameen.colors;
}
// export function useThemeComponentsColors(): SemanticTokens {
//   const theme = useTheme() as ExtendedMuiTheme;
//   return theme.ameen.colors.components['];
// }
/**
 * Hook to access the complete Ameen theme
 * 
 * @example
 * ```tsx
 * const { colors, spacing, borderRadius } = useAmeenTheme();
 * ```
 */
export function useAmeenTheme() {
  const theme = useTheme() as ExtendedMuiTheme;
  return theme.ameen;
}

/**
 * Hook to check if dark mode is active
 * 
 * @example
 * ```tsx
 * const isDark = useIsDarkMode();
 * ```
 */
export function useIsDarkMode(): boolean {
  const theme = useTheme() as ExtendedMuiTheme;
  return theme.ameen.mode === 'dark';
}

